// Redirect user to Stripe Payment Link
export const redirectToCheckout = async (userEmail) => {
  const paymentLink = process.env.REACT_APP_STRIPE_PAYMENT_LINK;

  if (!paymentLink) {
    throw new Error("Missing Stripe payment link. Check your .env file.");
  }

  // Append email so Stripe pre-fills it for the customer
  const url = `${paymentLink}?prefilled_email=${encodeURIComponent(userEmail)}`;
  window.location.href = url;
};